<template>
  <div class="AddOutLine">
    <AppHeader v-if="isAdd">
      <el-page-header
          @back="goBack"
          title="返回"
          :content="isAddContent"
      ></el-page-header>
      <el-button size="small" type="primary" @click="handleEditBaseInfo"
      >基础信息
      </el-button>
    </AppHeader>
    <AppHeader v-else>
      <el-page-header
          @back="goBack"
          title="返回"
          :content="isEditContent"
      ></el-page-header>
      <el-button size="small" type="primary" @click="handleEditBaseInfo"
      >基础信息
      </el-button>
    </AppHeader>
    <AppBox class="appBox">
      <div>
        <b>添加环节</b> |
        <span>点击预设环节或自定义添加，添加环节至课程流程</span>
      </div>
      <div class="exampleBox">
        <h5>预设环节</h5>
        <div class="moduleBox">
          <el-tooltip
              v-for="(item, index) in defaultOutLineArr"
              :key="index"
              effect="dark"
              placement="top"
          >
            <div slot="content" style="max-width: 200px">
              {{ item.tooltip }}
            </div>
            <div class="defaultModule" @click="handleDownAdd(item)">
              {{ item.module }}
            </div>
          </el-tooltip>
        </div>
        <hr/>
        <div class="addBtn">
          <span>自定义添加</span>
          <el-input
              ref="input"
              size="medium"
              style="width: 200px; margin: 0 30px"
              v-model="customModule"
              @focus="handleFocus"
              @blur="handleBlur"
              @keyup.enter.native="handleChange"
          ></el-input>
          <el-button size="small" type="primary" @click="handleAdd"
          >确认
          </el-button>
        </div>
      </div>
      <div>
        <b>课程流程</b> |
        <span>选中环节模块，可在前方插入环节，按删除键删除当前环节</span>
      </div>
      <div class="useAllBtn">
        <el-button size="small" plain type="primary" @click="handleReset"
        >清空课程流程
        </el-button>
        <el-button size="small" type="primary" @click="handleUseAll"
        >使用标准模板
        </el-button>
      </div>
      <div class="customBox">
        <div class="moduleBox">
          <div
              :class="isActive === index ? 'addClass' : ''"
              v-for="(item, index) in userArr"
              :key="index"
              class="userModule"
              @click="handleEdit(index)"
          >
            {{ SectionToChinese(index + 1) }}、{{ item.module }}
          </div>
        </div>
      </div>
      <div class="saveBox">
        <el-button
            style="width: 20%; margin-right: 50px"
            plain
            type="primary"
            @click="handleSave"
        >保存我的预设
        </el-button>
        <el-button style="width: 20%" type="primary" @click="handleConfirm"
        >生成课程流程
        </el-button>
      </div>
    </AppBox>
    <el-dialog title="提示" :visible.sync="deleteDialogVisible">
      <span>{{ deleteDialogText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button
            v-if="!existContent"
            size="small"
            @click="deleteDialogVisible = false">
          取 消
        </el-button>
        <el-button size="small" type="primary" @click="handleConfirmDelete">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import {mapActions, mapState} from "vuex";

export default {
  name: "AddOutLine",
  components: {AppHeader, AppBox},
  data() {
    return {
      deleteDialogVisible: false,
      deleteDialogText: "",
      existContent: false,
      isAdd: true,
      isAddContent: "课程管理 | 新增课程",
      isEditContent: "课程管理 | 编辑课程",
      customModule: "",
      defaultOutLineArr: [
        {
          type: "image,video,audioText",
          module: "上期回顾",
          trigger: null,
          // tooltip: "引入环节是课堂教学的重要组成部分，通过引入一个话题、问题或事例来吸引学生的注意力和激发学生的兴趣，引导学生进入本节课的主题和内容。"
          tooltip:
              "通过对上一节课内容的回顾，学生可以温习重要概念、知识点和关键细节。这有助于加深他们对课程内容的理解和记忆，并帮助他们将不同课堂之间的知识联系起来。",
        },
        {
          type: "image,video,audioText",
          module: "引入",
          trigger: null,
          tooltip:
              "引入环节是课堂教学的重要组成部分，通过引入一个话题、问题或事例来吸引学生的注意力和激发学生的兴趣，引导学生进入本节课的主题和内容。",
        },
        {
          type: "image,video,audioText",
          module: "案例",
          trigger: null,
          tooltip:
              "这一环节是可以通过一个具体的案例来说明本节课的学习内容，其中正面例子可以展示正确的应用方式和优秀的实践经验，而反面例子则可以警示学生要避免的错误做法和不良影响。",
        },
        {
          type: "select,judge,sort,imageSelect,multipleSelect",
          module: "判断",
          trigger: null,
          tooltip:
              "判断环节通常包括一些简单的选择题、判断题、填空题等,旨在检验学生对所学知识点的理解程度和应用能力，帮助学生及时发现自己的不足之处。",
        },
        {
          type: "audioText,image,video",
          module: "知识讲解",
          trigger: null,
          tooltip:
              "知识点环节是课堂教学的重点，教师会详细讲解本节课的核心知识点,包括相关概念、定义、原理等，让学生逐步理解和掌握所学知识。",
        },
        {
          type: "select,judge,sort,imageSelect,multipleSelect",
          module: "应用选择",
          trigger: null,
          tooltip:
              "应用选择环节是对知识点进行实际应用的环节，教师会提供多个应用场景，让学生根据所学知识点进行选择并解决问题，帮助学生将所学知识应用于实际问题中，提高学生的应用能力和解决问题的能力。",
        },
        {
          type: "audioText",
          module: "方法提炼",
          trigger: null,
          tooltip:
              "在应用过程中，教师会引导学生总结归纳出实际操作的方法和技巧，帮助学生发现知识点的规律和本质，提高学生的思维能力和创新能力。",
        },
        // {
        //   type: "text",
        //   module: "知识总结",
        //   tooltip: "知识点总结环节是对本节课的知识点进行梳理和总结，巩固学生的学习成果，帮助学生将所学知识点整合起来，形成系统性的知识结构。"
        // },
        {
          type: "select,judge,sort,imageSelect,multipleSelect",
          module: "情景判断",
          trigger: null,
          tooltip:
              "情景判断环节是通过情境模拟让学生进行实际操作和应用，旨在加深学生对所学知识点的理解和应用，提高学生的实践能力和解决问问题的能力。",
        },
        {
          type: "select,judge,sort,imageSelect,multipleSelect",
          module: "随堂测试",
          trigger: "CLASSROOM_TEST",
          tooltip:
              "随堂测试可以评估学生对课程内容的理解程度和掌握程度。通过测试，学生可以了解自己在学习上的强项和薄弱点，并及时发现并纠正知识上的不足之处。随堂测试还可以激发学生的学习兴趣，增加参与度，并帮助教师了解学生的学习情况，以便更好地调整教学策略。",
        },
        {
          type: "richText",
          module: "下节引入",
          trigger: "NEXT_SECTION_GUIDE",
          tooltip:
              "下一环节是介绍下一节课的主题和内容，让学生提前了解和准备。这样可以让学生对下一节课的学习内容有所了解，为学生的学习做好充分的准备。",
        },
      ],
      userArr: [],
      index: null,
      isActive: -1,
      outLineId: null,
    };
  },
  computed: {
    ...mapState("courseCenter", [
      "saveUserConfigDetail",
      "editOutLineDetail",
      "saveOutLineDetail",
    ]),
  },
  async mounted() {
    if (this.$route.params.type === "add") {
      this.isAdd = true;
    }
    if (this.$route.params.type === "edit") {
      this.isAdd = false;
    }
    await this.getLessonEditOutline({
      id: Number(this.$Base64.decode(this.$route.params.lessonId)),
    });
    if (this.editOutLineDetail) {
      this.outLineId = this.editOutLineDetail.id;
      this.userArr = this.editOutLineDetail.outline;
    } else {
      await this.getUserConfig({
        type: "saveOutLine",
      });
      this.outLineId = null;
      if (!this.saveUserConfigDetail) {
        this.userArr = [];
      } else {
        this.userArr = this.saveUserConfigDetail;
      }
    }
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    ...mapActions("courseCenter", [
      "getUserConfig",
      "saveUserConfig",
      "saveLessonVersion",
      "getLessonEditOutline",
    ]),
    goBack() {
      localStorage.setItem("isActive", JSON.stringify("isTrue"));
      this.$router.go(-1);
    },
    async handleEditBaseInfo() {
      if (this.$route.params.type === "add") {
        localStorage.setItem("isActive", JSON.stringify("isTrue"));
      } else {
        localStorage.setItem("isActive", JSON.stringify("isFalse"));
      }
      await this.$router.push(
          {
            name: "AddCourse",
            params: {
              classSubjectId: this.$route.params.classSubjectId,
              classSubjectName: this.$route.params.classSubjectName,
              type: this.$route.params.type,
            },
          },
          () => {
          }
      );
    },
    // 预设模块单个向下添加
    handleDownAdd(row) {
      const obj = {};
      this.$set(obj, "module", row.module);
      this.$set(obj, "type", row.type);
      this.$set(obj, "trigger", row.trigger);
      const addModule = obj.module;
      if (this.index != null) {
        window.removeEventListener("keydown", this.handleKeyDown);
        const result = this.hasLightJudgeFun(addModule);
        if (result) {
          // 向前追加
          this.userArr.splice(this.index, 0, obj);
          // 追加完成之后回复默认值，按钮取消高亮
          this.isActive = -1;
          this.index = null;
          window.addEventListener("keydown", this.handleKeyDown);
        }
      } else {
        const i = this.userArr.length - 1;
        const result = this.hasNoLightJudgeFun(addModule, i);
        if (result) {
          this.userArr.push(obj);
          this.index = null;
          this.isActive = -1;
        }
      }
    },
    handleFocus() {
      window.removeEventListener("keydown", this.handleKeyDown);
    },
    handleBlur() {
      window.addEventListener("keydown", this.handleKeyDown);
    },
    handleChange() {
      // 判断输入框有没有文字
      if (!this.customModule) {
        return;
      }
      // 创建单个模块，包括type，module
      const obj = {};
      this.$set(obj, "module", this.customModule);
      this.$set(obj, "type", "custom");
      if (this.customModule === "随堂测试") {
        this.$set(obj, "trigger", "CLASSROOM_TEST");
      } else if (this.customModule === "下节引入") {
        this.$set(obj, "trigger", "NEXT_SECTION_GUIDE");
      } else {
        this.$set(obj, "trigger", null);
      }
      // 如果有index，说明已被选中有高亮，向前追加，没有则默认按顺序追加
      const addModule = obj.module;
      if (this.index != null) {
        window.removeEventListener("keydown", this.handleKeyDown);
        const result = this.hasLightJudgeFun(addModule);
        if (result) {
          // 向前追加
          this.userArr.splice(this.index, 0, obj);
          // 追加完成之后回复默认值，按钮取消高亮
          this.isActive = -1;
          this.index = null;
          this.$refs.input.blur();
          this.customModule = "";
        }
      } else {
        // 按顺序从末尾追加
        const i = this.userArr.length - 1;
        // 如果我的大纲有内容并且最后一个模块是下节引入
        const result = this.hasNoLightJudgeFun(addModule, i);
        if (result) {
          this.userArr.push(obj);
          // 追加完成之后回复默认值，按钮取消高亮
          this.isActive = -1;
          this.index = null;
          this.$refs.input.blur();
          this.customModule = "";
        }
      }
    },
    // 自定义添加
    handleAdd() {
      // 判断输入框有没有文字
      if (!this.customModule) {
        return;
      }
      // 创建单个模块，包括type，module
      const obj = {};
      this.$set(obj, "module", this.customModule);
      this.$set(obj, "type", "custom");
      if (this.customModule === "随堂测试") {
        this.$set(obj, "trigger", "CLASSROOM_TEST");
      } else if (this.customModule === "下节引入") {
        this.$set(obj, "trigger", "NEXT_SECTION_GUIDE");
      } else {
        this.$set(obj, "trigger", null);
      }
      // 如果有index，说明已被选中有高亮，向前追加，没有则默认按顺序追加
      const addModule = obj.module;
      if (this.index != null) {
        window.removeEventListener("keydown", this.handleKeyDown);
        const result = this.hasLightJudgeFun(addModule);
        if (result) {
          // 向前追加
          this.userArr.splice(this.index, 0, obj);
          // 追加完成之后回复默认值，按钮取消高亮
          this.isActive = -1;
          this.index = null;
          this.customModule = "";
          window.addEventListener("keydown", this.handleKeyDown);
        }
      } else {
        // 按顺序从末尾追加
        const i = this.userArr.length - 1;
        // 如果我的大纲有内容并且最后一个模块是下节引入
        const result = this.hasNoLightJudgeFun(addModule, i);
        if (result) {
          this.userArr.push(obj);
          // 追加完成之后回复默认值，按钮取消高亮
          this.isActive = -1;
          this.index = null;
          this.customModule = "";
        }
      }
    },
    //清空我的大纲
    handleReset() {
      this.isActive = -1;
      this.index = null;
      window.removeEventListener("keydown", this.handleKeyDown);

      if (this.userArr.every((item) => !item.existContent)) {
        this.$confirm("请确认是否要清空当前课程流程!", "提示", {
          showCancelButton: false,
          confirmButtonText: "确定",
          type: "warning",
        })
            .then(() => {
              this.userArr = [];
              this.customModule = "";
            })
            .catch(() => {
              // Do nothing on cancel
            });
      } else {
        this.$confirm("当前流程内已有添加的课程内容，请删除后重试!", "提示", {
          showCancelButton: false,
          confirmButtonText: "确定",
          type: "warning",
        }).catch(() => {
          // Do nothing on cancel
        });
      }

      window.addEventListener("keydown", this.handleKeyDown);
    },
    // 使用标准模板
    handleUseAll() {
      this.isActive = -1;
      this.index = null;
      window.removeEventListener("keydown", this.handleKeyDown);

      if (this.userArr.length < 1) {
        const newArr = this.defaultOutLineArr.map((item) => ({
          ...item,
          tooltip: undefined,
        }));
        this.userArr = newArr;
      } else if (this.userArr.every((item) => !item.existContent)) {
        this.$confirm(
            "请确认是否要清空课程流程，按照标准模板重新生成!",
            "提示",
            {
              confirmButtonText: "确定",
              type: "warning",
            }
        )
            .then(() => {
              const newArr = this.defaultOutLineArr.map((item) => ({
                ...item,
                tooltip: undefined,
              }));
              this.userArr = newArr;
            })
            .catch(() => {
              // Do nothing on cancel
            });
      } else {
        this.$confirm("当前流程内已有添加的课程内容，请删除后重试!", "提示", {
          showCancelButton: false,
          confirmButtonText: "确定",
          type: "warning",
        }).catch(() => {
          // Do nothing on cancel
        });
      }

      window.addEventListener("keydown", this.handleKeyDown);
    },

    // 选中大纲模块，进行向前追加、删除操作
    handleEdit(index) {
      // 判断当前是否高亮，如果是点击则取消高亮，恢复默认值
      if (this.index === index || this.isActive === index) {
        this.index = null;
        this.isActive = -1;
        return;
      }
      // 不是则进行赋值，变成高亮
      this.isActive = index;
      this.index = index;
    },
    // 保存我的预设
    async handleSave() {
      if (this.userArr.length < 1) {
        this.$confirm("当前没有可保存的预设内容,请先制作您的课程流程", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
            .then(async () => {
            })
            .catch(() => {
            });
        return;
      }
      // 判断剩下的项的module是否只有"随堂测试"和"下节引入"
      const uniqueArr = Array.from(
          new Set(this.userArr.map((item) => JSON.stringify(item)))
      ).map((item) => JSON.parse(item));
      const isOnlyReviewAndIntroduction = uniqueArr.every(
          (item) => item.module === "随堂测试" || item.module === "下节引入"
      );
      if (isOnlyReviewAndIntroduction) {
        this.$confirm(
            "课程流程中不能仅包含随堂测试和下节引入环节，请调整后重试！",
            "提示",
            {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning",
            }
        )
            .then(async () => {
            })
            .catch(() => {
            });
        return;
      }

      await this.saveUserConfig({
        data: JSON.parse(JSON.stringify(this.userArr)),
        type: "saveOutLine",
      });
      await this.getUserConfig({
        type: "saveOutLine",
      });
      this.userArr = this.saveUserConfigDetail;
    },
    // 生成课程大纲，跳转至下一个页面
    async handleConfirm() {
      if (this.userArr.length < 1) {
        this.$confirm("您的课流程暂未制作,请先制作您的课程流程", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
            .then(async () => {
            })
            .catch(() => {
            });
        return;
      }
      // 判断剩下的项的module是否只有"随堂测试"和"下节引入"
      const uniqueArr = Array.from(
          new Set(this.userArr.map((item) => JSON.stringify(item)))
      ).map((item) => JSON.parse(item));
      const isOnlyReviewAndIntroduction = uniqueArr.every(
          (item) => item.module === "随堂测试" || item.module === "下节引入"
      );
      if (isOnlyReviewAndIntroduction) {
        this.$confirm(
            "课程流程中不能仅包含随堂测试和下节引入环节，请调整后重试！",
            "提示",
            {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning",
            }
        )
            .then(async () => {
            })
            .catch(() => {
            });
        return;
      }

      await this.saveLessonVersion({
        id: this.outLineId,
        lessonId: Number(this.$Base64.decode(this.$route.params.lessonId)),
        outline: this.userArr,
      });
      var type;
      if (this.outLineId) {
        this.$message.success("编辑课程流程成功");
        type = "edit";
      } else {
        this.$message.success("生成课程流程成功");
        type = "add";
      }
      await this.$router.push(
          {
            name: "MyOutLine",
            params: {
              lessonId: this.$route.params.lessonId,
              classSubjectId: this.$route.params.classSubjectId,
              classSubjectName: this.$route.params.classSubjectName,
              type: type,
            },
          },
          () => {
          }
      );
    },
    handleKeyDown(event) {
      const self = this;
      event = event || window.event;
      const keyCode = event.which || event.keyCode;
      if (self.index !== null) {
        if (keyCode === 8 || keyCode === 46) {
          this.existContent = self.userArr[self.index].existContent;
          if (this.existContent) {
            this.deleteDialogVisible = true;
            this.deleteDialogText =
                "当前环节下已添加课程内容，请删除内容后操作!";
          } else {
            this.deleteDialogVisible = true;
            this.deleteDialogText = "请确认是否要删除该环节?";
          }
        }
      }
    },
    // 我的大纲有高亮时，添加大纲的判断公用方法
    hasLightJudgeFun(name) {
      if (name === "下节引入") {
        this.$confirm("下节引入环节唯一，且仅可作为课程最后一个环节!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              window.addEventListener("keydown", this.handleKeyDown);
            })
            .catch(() => {
              window.addEventListener("keydown", this.handleKeyDown);
            });
        return false;
      } else if (name === "随堂测试") {
        if (this.userArr[this.index].module !== "下节引入") {
          this.$confirm(
              "随堂测试环节唯一，且后面仅可添加下节引入环节!",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              }
          )
              .then(async () => {
                window.addEventListener("keydown", this.handleKeyDown);
              })
              .catch(() => {
                window.addEventListener("keydown", this.handleKeyDown);
              });
          return false;
        } else if (
            this.index >= 1 &&
            this.userArr[this.index - 1].module === "随堂测试"
        ) {
          this.$confirm(
              "随堂测试环节唯一，且后面仅可添加下节引入环节!",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              }
          )
              .then(async () => {
                window.addEventListener("keydown", this.handleKeyDown);
              })
              .catch(() => {
                window.addEventListener("keydown", this.handleKeyDown);
              });
          return false;
        }
      } else if (name === "上期回顾") {
        if (this.index >= 1) {
          this.$confirm(
              "上期回顾环节唯一，且仅可添加在流程内第一个环节!",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              }
          )
              .then(async () => {
                window.addEventListener("keydown", this.handleKeyDown);
              })
              .catch(() => {
                window.addEventListener("keydown", this.handleKeyDown);
              });
          return false;
        } else if (this.userArr[this.index].module === "上期回顾") {
          this.$confirm(
              "上期回顾环节唯一，且仅可添加在流程内第一个环节!",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              }
          )
              .then(async () => {
                window.addEventListener("keydown", this.handleKeyDown);
              })
              .catch(() => {
                window.addEventListener("keydown", this.handleKeyDown);
              });
          return false;
        }
      } else {
        if (
            this.index >= 1 &&
            this.userArr[this.index - 1].module === "随堂测试" &&
            this.userArr[this.index].module === "下节引入"
        ) {
          this.$confirm(
              "随堂测试环节唯一，且后面仅可添加下节引入环节!!",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              }
          )
              .then(async () => {
                window.addEventListener("keydown", this.handleKeyDown);
              })
              .catch(() => {
                window.addEventListener("keydown", this.handleKeyDown);
              });
          return false;
        }
        if (this.userArr[this.index].module === "上期回顾") {
          this.$confirm(
              "上期回顾环节唯一，且仅可添加在流程内第一个环节!",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              }
          )
              .then(async () => {
                window.addEventListener("keydown", this.handleKeyDown);
              })
              .catch(() => {
                window.addEventListener("keydown", this.handleKeyDown);
              });
          return false;
        }
      }
      return true;
    },
    // 我的大纲没有高亮时，添加大纲的判断公用方法
    hasNoLightJudgeFun(name, i) {
      if (i >= 0 && this.userArr[i]) {
        if (this.userArr[i].module === "下节引入") {
          this.$confirm(
              "下节引入为课程最后环节，要想继续添加其他环节，请先删除下节引入或在前方插入!",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              }
          )
              .then(async () => {
              })
              .catch(() => {
              });
          return false;
        } else if (
            this.userArr[i].module === "随堂测试" &&
            name !== "下节引入"
        ) {
          this.$confirm(
              "随堂测试环节唯一，且后面仅可添加下节引入环节!！",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              }
          )
              .then(async () => {
              })
              .catch(() => {
              });
          return false;
        } else if (name === "上期回顾") {
          this.$confirm(
              "上期回顾环节唯一，且仅可添加在流程内第一个环节!",
              "提示",
              {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              }
          )
              .then(async () => {
              })
              .catch(() => {
              });
          return false;
        }
      }
      return true;
    },
    handleConfirmDelete() {
      if (this.existContent) {
        this.deleteDialogVisible = false;
      } else {
        const arr = this.userArr;
        arr.splice(this.index, 1);
        if (this.userArr.length === this.index) {
          this.index = this.index - 1;
          this.isActive = this.index;
        }
        this.userArr = arr;
        if (this.index === -1) {
          this.index = null;
          this.isActive = -1;
        }
        this.deleteDialogVisible = false;
      }
    },
    // 根据index生成中文序号
    SectionToChinese(section) {
      var chnNumChar = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      var chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
      var strIns = "",
          chnStr = "";
      var unitPos = 0;
      var zero = true;
      while (section > 0) {
        var v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      chnStr = chnStr.replace(/^一十/g, "十");
      return chnStr;
    },
  },
};
</script>

<style lang="scss" scoped>
.AddOutLine {
  .appBox {
    width: 100%;
    min-height: calc(100vh - 165px);

    .exampleBox {
      margin: 30px 0 60px 0;
      padding: 20px;
      background: #f2f2f2;
      border-radius: 5px;

      .moduleBox {
        min-height: 100px;
        margin: 20px 0;

        .defaultModule {
          display: inline-block;
          min-width: 100px;
          border-radius: 3px;
          margin-right: 50px;
          margin-bottom: 20px;
          transition: transform 0.1s;
          box-shadow: 0 2px 15px #10689c;
          background: #10689c;
          color: #fff;
          text-align: center;
          padding: 8px;
          cursor: pointer;
        }

        .defaultModule:hover {
          background: #10689c;
          color: #fff;
          transform: translate(0, -5px);
          box-shadow: 0 10px 30px #10689c;
        }
      }

      .addBtn {
        margin-top: 20px;
      }
    }

    .useAllBtn {
      text-align: right;
    }

    .customBox {
      margin: 10px 0 40px 0;
      padding: 20px;
      background: #f2f2f2;
      border-radius: 5px;

      .moduleBox {
        min-height: 110px;
        margin: 20px 0;

        .userModule {
          display: inline-block;
          min-width: 140px;
          border-radius: 3px;
          border: 1px solid #10689c;
          margin-right: 50px;
          margin-bottom: 20px;
          background: #f0f2fa;
          color: #10689c;
          padding: 8px;
          cursor: pointer;
        }

        .addClass {
          background: #10689c;
          box-shadow: 0 2px 15px #10689c;
          display: inline-block;
          min-width: 140px;
          border-radius: 3px;
          margin-right: 50px;
          margin-bottom: 20px;
          color: #fff;
          padding: 8px;
          cursor: pointer;
        }
      }
    }

    .saveBox {
      width: 100%;
      text-align: center;
    }
  }

  ::v-deep .el-dialog {
    margin-top: 44vh !important;
    width: 450px;
  }

  ::v-deep .el-dialog .el-dialog__header {
    box-shadow: none;
  }
}
</style>
